// Builds a tree-like structure compatible with the existing trees slice
// (loadTree). The root is the team itself; channels are direct children.
// Mirrors the shape produced by parseMailFolders so MailCategories-style
// drawer components can reuse the same indices/childrenIdx layout.
export const buildTeamTree = (team, channels = []) => {
  const root = {
    ...team,
    displayName: team.display_name,
    idx: 0,
    parentIdx: null,
    childrenIdx: [],
  };
  const nodes = [root];
  channels.forEach((channel, i) => {
    const idx = nodes.length;
    nodes.push({
      ...channel,
      displayName: channel.display_name,
      idx,
      parentIdx: 0,
      childrenIdx: [],
    });
    root.childrenIdx.push(idx);
  });
  return nodes;
};

// Defensive parser: from_user / attachments come as JSON strings inside the DTO.
export const safeJSONParse = (raw, fallback = null) => {
  if (raw === undefined || raw === null || raw === "") return fallback;
  if (typeof raw !== "string") return raw;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return fallback;
  }
};

// The `body` of a Teams chatMessage arrives as a JSON string shaped like a
// Microsoft Graph `itemBody`: `{ "contentType": "html", "content": "<div>…" }`.
// This returns the renderable HTML so views never display the raw JSON. When
// the content is plain text it is wrapped so newlines survive, and when the
// value is not JSON-wrapped it is returned as-is (assumed already HTML).
export const extractMessageHtml = (body) => {
  if (!body) return "";
  const parsed = safeJSONParse(body);
  if (parsed && typeof parsed === "object" && typeof parsed.content === "string") {
    const contentType = String(
      parsed.contentType ?? parsed.content_type ?? ""
    ).toLowerCase();
    if (contentType === "text") {
      const escaped = parsed.content
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
      return `<pre style="white-space:pre-wrap;font-family:inherit;margin:0">${escaped}</pre>`;
    }
    return parsed.content;
  }
  return typeof body === "string" ? body : "";
};

// Extracts a human-readable display name from a Microsoft Graph
// chatMessage `from` identity (already parsed to an object).
export const extractFromUserName = (fromObj) => {
  if (!fromObj) return "";
  const u =
    fromObj.user ??
    fromObj.application ??
    fromObj.device ??
    fromObj.emailAddress ??
    fromObj;
  return u?.displayName ?? u?.name ?? u?.id ?? "";
};
